import React from 'react';
import { Button, Typography } from '@mui/material';
import { AppRow } from '../../layout/appRow';
import { ViewMode } from '../../models/preferences';

interface AppViewModeSelectorProps {
  viewMode: ViewMode;
  handleChangeViewMode: (viewModeArg: ViewMode) => void;
}

const styles = {
  viewModebtn: {
    fontSize: '14px',
    mr: 0.5,
  },

  viewModeText: {
    display: 'flex',
    alignItems: 'center',
    mr: 1,
  },
};

export function AppViewModeSelector({
  handleChangeViewMode,
  viewMode,
}: AppViewModeSelectorProps): JSX.Element {
  return (
    <>
      <Typography variant="body2" sx={styles.viewModeText}>
        View mode:
      </Typography>
      <AppRow  sx={{ gap: '16px' }}>
        <Button
          variant="contained"
          onClick={() => handleChangeViewMode(ViewMode.DAY)}
          disabled={viewMode == ViewMode.DAY}
          sx={styles.viewModebtn}
        >
          Day
        </Button>
        <Button
          variant="contained"
          onClick={() => handleChangeViewMode(ViewMode.WORK_WEEK)}
          disabled={viewMode == ViewMode.WORK_WEEK}
          sx={styles.viewModebtn}
        >
          Work Week
        </Button>
        <Button
          variant="contained"
          onClick={() => handleChangeViewMode(ViewMode.WEEK)}
          disabled={viewMode == ViewMode.WEEK}
          sx={styles.viewModebtn}
        >
          Week
        </Button>
        <Button
          variant="contained"
          onClick={() => handleChangeViewMode(ViewMode.MONTH)}
          disabled={viewMode == ViewMode.MONTH}
        >
          Month
        </Button>
        <Button
          variant="contained"
          onClick={() => handleChangeViewMode(ViewMode.OLD_VIEW)}
          disabled={viewMode == ViewMode.OLD_VIEW}
        >
          List view
        </Button>
      </AppRow>
    </>
  );
}
